import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const ElementTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    Api.get('types/building-elements?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(element => ({
          label: `${element.name} [${element.code}]`,
          value: element.id,
        }));
        setElements(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = elements.find(x => x.value === selectedId);
  }
  return (
    <Select
      isMulti={isMulti}
      options={elements}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Element Type"
    />
  );
};

ElementTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

ElementTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default ElementTypeSelector;
